import React, { useState } from "react";
import Navbar from "./components/Navbar";
import Hero from "./components/Hero";
import Features from "./components/Features";
import CoreCapabilities from "./components/CoreCapabilities";
import Footer from "./components/Footer";
import ScrollFeature, { scrollData } from "./components/ScrollFeature";
import './styles/main.css';

function App() {
  const [lang, setLang] = useState("en");

  const content = {
    en: {
      title: "AI-driven Enterprise Transformation",
      subtitle: "We help every company go digital with cutting-edge AI systems",
      contact: "Contact: 625139432 | hongye.song.pro@gmail.com",
      partners: "Partners: Microsoft · OpenAI · CVC · China Unicom · UAB · China Everbright Bank",
    },
    zh: {
      title: "AI 驱动企业数字化转型",
      subtitle: "帮助每一位客户实现企业线上化并落地新型 AI 技术",
      contact: "联系电话：625139432 | 邮箱：hongye.song.pro@gmail.com",
      partners: "合作方：微软 · OpenAI · CVC · 中国联通 · UAB · 中国光大银行",
    },
    es: {
      title: "Transformación Digital con IA",
      subtitle: "Ayudamos a cada empresa a digitalizarse con inteligencia artificial",
      contact: "Contacto: 625139432 | hongye.song.pro@gmail.com",
      partners: "Socios: Microsoft · OpenAI · CVC · China Unicom · UAB · China Everbright Bank",
    },
  };

  const t = content[lang];
  const scroll = scrollData[lang];

  return (
    <div className="app-container">
      <Navbar setLang={setLang} />
      <Hero t={t} />
      <CoreCapabilities lang={lang} />
      <Features lang={lang} />

      <ScrollFeature isHeader lang={lang} />

      <div className="scroll-features-grid">
        {scroll.items.map((item, i) => (
          <ScrollFeature
            key={i}
            title={item.title}
            points={item.points}
            img={`/img/${i + 1}.jpg`}
          />
        ))}
      </div>

      <Footer t={t} />
    </div>
  );
}

export default App;
